__webpack_require__.p = "/NewsWebsite/";